import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kharghartaxiservice() {



    const cardData = {
"keyword": "Kharghar Taxi Services",

"headingDescription":
  "Om Sai Cab offers reliable and comfortable Kharghar Taxi Services for travelers looking for safe, affordable, and convenient local and outstation travel in and around Navi Mumbai. Whether you need airport transfers, daily commuting, business travel, family trips, railway station pickups, or sightseeing tours, our taxi service ensures a smooth and stress-free journey from Kharghar to any destination. With experienced drivers familiar with Navi Mumbai routes, clean air-conditioned vehicles maintained for comfort, and transparent pricing with no hidden charges, we provide a dependable travel solution for every passenger. Our fleet includes sedans, SUVs, Innova cars, tempo travellers, and premium vehicles suitable for solo travelers, families, and groups.",

"topPlaces": [
  {
    "title": "Pune",
    "description": "Travel from Kharghar to Pune, a major IT, education, and manufacturing hub in Maharashtra."
  },
  {
    "title": "Lonavala",
    "description": "Travel from Kharghar to Lonavala, a popular hill station known for its scenic landscapes and pleasant climate."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Travel from Kharghar to Mahabaleshwar, a renowned hill station famous for its viewpoints and strawberry farms."
  },
  {
    "title": "Nashik",
    "description": "Travel from Kharghar to Nashik, an important industrial city known for vineyards and religious attractions."
  },
  {
    "title": "Shirdi",
    "description": "Travel from Kharghar to Shirdi, one of India's most visited pilgrimage destinations dedicated to Sai Baba."
  },
  {
    "title": "Goa",
    "description": "Travel from Kharghar to Goa, a famous destination known for its beaches, resorts, and vibrant nightlife."
  },
  {
    "title": "Aurangabad",
    "description": "Travel from Kharghar to Aurangabad, a historic city and gateway to the Ajanta and Ellora Caves."
  },
  {
    "title": "Kolhapur",
    "description": "Travel from Kharghar to Kolhapur, a cultural and commercial city known for temples, cuisine, and industries."
  },
  {
    "title": "Surat",
    "description": "Travel from Kharghar to Surat, India's leading textile and diamond business center."
  },
  {
    "title": "Ahmedabad",
    "description": "Travel from Kharghar to Ahmedabad, a major commercial, industrial, and financial hub in Gujarat."
  }
],



services: [
  {
    name: "Cab Service in Kharghar",
    description: "Cab service in Kharghar provides reliable transportation for travelers planning comfortable local and outstation road journeys. Vehicles ensure smooth city and highway travel suitable for airport transfers, tourism trips, business travel, and family outings. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Kharghar. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Kharghar Taxi Services",
    description: "Kharghar taxi services offer dependable transportation with comfortable vehicles for local and long-distance travel requirements. Vehicles ensure reliable road journeys suitable for airport transfers, tourism travel, family vacations, and executive trips. Professional chauffeurs ensure safe driving and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Kharghar. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Kharghar Cab Service",
    description: "Kharghar cab service provides comfortable transportation for travelers seeking smooth and safe local and outstation road travel. Vehicles ensure reliable city and highway journeys suitable for airport travel, tourism trips, family outings, and business travel. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Kharghar. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Kharghar Taxi Booking",
    description: "Kharghar taxi booking service provides easy transportation reservations for travelers planning comfortable road journeys from Kharghar. Comfortable vehicles ensure smooth city and highway travel suitable for tourism travel, airport transfers, and executive trips. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Kharghar. Flexible booking options allow convenient taxi booking reservations."
  },
  {
    name: "Kharghar Outstation Taxi",
    description: "Kharghar outstation taxi service provides dependable long-distance transportation for travelers planning smooth intercity road journeys. Vehicles ensure reliable highway travel suitable for tourism trips, sightseeing tours, family vacations, and business travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby areas across Kharghar. Flexible booking options allow convenient outstation taxi reservations."
  },
  {
    name: "Kharghar AC Cab Service",
    description: "Kharghar AC cab service provides air-conditioned transportation for comfortable and relaxing local and outstation travel. Vehicles ensure cool and smooth road journeys suitable for airport transfers, tourism travel, family outings, and executive trips. Professional chauffeurs ensure reliable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Kharghar. Flexible booking options allow convenient AC cab reservations."
  },
  {
    name: "Kharghar Airport Taxi",
    description: "Kharghar airport taxi service provides direct airport transportation for travelers planning comfortable pickup and drop journeys. Vehicles ensure smooth city and highway travel suitable for airport transfers, tourism travel, executive journeys, and family vacations. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby airport locations across Kharghar. Flexible booking options allow convenient airport taxi reservations."
  },
  {
    name: "Kharghar Tourist Taxi Service",
    description: "Kharghar tourist taxi service offers dependable transportation for tourists planning sightseeing tours and comfortable road travel. Vehicles ensure reliable local and highway journeys suitable for tourism trips, family vacations, beach visits, and nearby sightseeing travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from hotels, homes, railway stations, and nearby tourist locations across Kharghar. Flexible booking options allow convenient tourist taxi reservations."
  },
  {
    name: "Kharghar One Way Cab",
    description: "Kharghar one way cab service provides economical transportation for travelers requiring direct one-side road travel. Comfortable vehicles ensure smooth highway journeys suitable for solo travelers, tourists, couples, and family travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Kharghar. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Kharghar Outstation Cab",
    description: "Kharghar outstation cab service provides reliable long-distance transportation for travelers planning comfortable intercity road journeys. Vehicles ensure smooth highway travel suitable for tourism trips, family holidays, business travel, and sightseeing tours. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby areas across Kharghar. Flexible booking options allow convenient outstation cab reservations."
  },
  {
    name: "Kharghar Outstation Cab Service",
    description: "Kharghar outstation cab service offers dependable transportation solutions for travelers seeking smooth and safe intercity road travel. Comfortable vehicles ensure reliable highway journeys suitable for tourism travel, family vacations, executive travel, and holiday trips. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Kharghar. Flexible booking options allow convenient outstation cab service reservations."
  },
  {
    name: "Kharghar One Way Outstation Cab",
    description: "Kharghar one way outstation cab service provides affordable transportation for travelers planning direct one-side intercity road travel. Vehicles ensure smooth highway journeys suitable for tourism trips, family travel, executive journeys, and solo travelers. Professional chauffeurs ensure reliable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Kharghar. Flexible booking options allow convenient one-way outstation cab reservations."
  },
  {
    name: "Kharghar Tourist Cab",
    description: "Kharghar tourist cab service provides comfortable transportation for tourists planning sightseeing tours and holiday road travel. Vehicles ensure reliable city and highway journeys suitable for tourism trips, family vacations, nearby beach visits, and outstation travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, resorts, railway stations, and nearby tourist locations across Kharghar. Flexible booking options allow convenient tourist cab reservations."
  },
  {
    name: "Kharghar Intercity Taxi Service",
    description: "Kharghar intercity taxi service offers dependable transportation for travelers planning smooth long-distance road journeys from Kharghar. Vehicles ensure reliable highway travel suitable for tourism trips, business travel, executive journeys, and family vacations. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Kharghar. Flexible booking options allow convenient intercity taxi reservations."
  },
  {
    name: "Kharghar Private Taxi Service",
    description: "Kharghar private taxi service provides exclusive transportation for travelers seeking privacy and flexible travel schedules. Comfortable vehicles ensure smooth city and highway journeys suitable for couples, families, executive travel, and airport transfers. Professional chauffeurs ensure dependable pickup and premium transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Kharghar. Flexible booking options allow convenient private taxi reservations."
  },
  {
    name: "Kharghar to Pune Cab",
    description: "Kharghar to Pune cab service provides reliable transportation for travelers planning comfortable road journeys between Kharghar and Pune. Vehicles ensure smooth highway travel suitable for tourism travel, business trips, family outings, and weekend journeys. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Kharghar. Flexible booking options allow convenient Pune cab reservations."
  },
  {
    name: "Kharghar to Pune Cab Service",
    description: "Kharghar to Pune cab service offers dependable transportation solutions for travelers seeking safe and smooth road travel to Pune. Comfortable vehicles ensure reliable highway journeys suitable for executive travel, tourism trips, and family vacations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Kharghar. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Kharghar to Pune Taxi",
    description: "Kharghar to Pune taxi service provides comfortable transportation for travelers planning direct road journeys from Kharghar to Pune. Vehicles ensure smooth highway travel suitable for tourism trips, executive journeys, and family travel. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Kharghar. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Kharghar to Pune Taxi Service",
    description: "Kharghar to Pune taxi service offers reliable transportation with comfortable vehicles for travelers planning smooth intercity road journeys. Vehicles ensure dependable highway travel suitable for tourism trips, family vacations, and business travel. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Kharghar. Flexible booking options allow convenient taxi service reservations."
  },
  {
    name: "Kharghar to Pune One Way Cab",
    description: "Kharghar to Pune one way cab service provides economical transportation for travelers requiring direct one-side road travel to Pune. Comfortable vehicles ensure smooth highway journeys suitable for tourists, couples, solo travelers, and family travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Kharghar. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Kharghar to Pune Outstation Cab",
    description: "Kharghar to Pune outstation cab service provides dependable long-distance transportation for travelers planning comfortable intercity road journeys. Vehicles ensure reliable highway travel suitable for tourism trips, business travel, family vacations, and sightseeing tours. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby areas across Kharghar. Flexible booking options allow convenient outstation cab reservations."
  },
  {
    name: "Kharghar to Goa Cabs",
    description: "Kharghar to Goa cabs service provides reliable transportation for travelers planning comfortable road journeys from Kharghar to Goa. Vehicles ensure smooth highway travel suitable for beach holidays, tourism travel, family vacations, and sightseeing tours. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Kharghar. Flexible booking options allow convenient Goa cab reservations."
  },
  {
    name: "Kharghar to Goa Cab Service",
    description: "Kharghar to Goa cab service offers dependable transportation solutions for travelers seeking smooth and safe road travel to Goa. Comfortable vehicles ensure reliable highway journeys suitable for tourism trips, family vacations, and holiday travel. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby areas across Kharghar. Flexible booking options allow convenient Goa cab service reservations."
  },
  {
    name: "Kharghar to Goa Taxi",
    description: "Kharghar to Goa taxi service provides comfortable transportation for travelers planning direct road journeys from Kharghar to Goa. Vehicles ensure smooth highway travel suitable for tourism trips, beach holidays, and family travel. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Kharghar. Flexible booking options allow convenient Goa taxi reservations."
  },
  {
    name: "Kharghar to Goa Taxi Service",
    description: "Kharghar to Goa taxi service offers reliable transportation with comfortable vehicles for travelers planning smooth intercity road journeys. Vehicles ensure dependable highway travel suitable for tourism trips, family vacations, and holiday outings. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Kharghar. Flexible booking options allow convenient Goa taxi service reservations."
  },
  {
    name: "Kharghar to Goa One Way Cab",
    description: "Kharghar to Goa one way cab service provides economical transportation for travelers requiring direct one-side road travel to Goa. Comfortable vehicles ensure smooth highway journeys suitable for tourists, couples, solo travelers, and family vacations. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Kharghar. Flexible booking options allow convenient one-way Goa cab reservations."
  },
  {
    name: "Kharghar to Goa Outstation Cab",
    description: "Kharghar to Goa outstation cab service provides dependable long-distance transportation for travelers planning comfortable intercity road journeys. Vehicles ensure reliable highway travel suitable for tourism trips, beach holidays, family vacations, and sightseeing tours. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Kharghar. Flexible booking options allow convenient Goa outstation cab reservations."
  },
  {
    name: "Best Kharghar to Goa Cab",
    description: "Best Kharghar to Goa cab service provides premium transportation with comfortable vehicles and experienced chauffeurs for smooth Goa road journeys. Vehicles ensure reliable highway travel suitable for beach vacations, tourism trips, family holidays, and executive travel. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Kharghar. Flexible booking options allow convenient premium Goa cab reservations."
  },
  {
    name: "Cheap Kharghar to Goa Taxi",
    description: "Cheap Kharghar to Goa taxi service offers budget-friendly transportation for solo travelers, tourists, couples, and families traveling to Goa. Comfortable vehicles ensure smooth and reliable highway journeys suitable for tourism and holiday travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Kharghar. Flexible booking options allow convenient low-cost Goa taxi reservations."
  },
  {
    name: "Online Kharghar to Goa Cab Booking",
    description: "Online Kharghar to Goa cab booking service provides quick and convenient transportation reservations for travelers planning comfortable Goa road journeys. Vehicles ensure smooth highway travel suitable for tourism travel, family vacations, and beach holiday trips. Professional chauffeurs ensure reliable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Kharghar. Flexible online booking options allow convenient Goa cab reservations."
  },
  {
    name: "Kharghar to Nashik Cab",
    description: "Kharghar to Nashik cab service provides reliable transportation for travelers planning comfortable road journeys between Kharghar and Nashik. Vehicles ensure smooth highway travel suitable for tourism trips, pilgrimage travel, family outings, and business journeys. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby areas across Kharghar. Flexible booking options allow convenient Nashik cab reservations."
  }
],

tableData: [
  ["Cab Service in Kharghar", "Kharghar Taxi Services"],
  ["Kharghar Cab Service", "Kharghar Taxi Booking"],
  ["Kharghar Outstation Taxi", "Kharghar AC Cab Service"],
  ["Kharghar Airport Taxi", "Kharghar Tourist Taxi Service"],
  ["Kharghar One Way Cab", "Kharghar Outstation Cab"],
  ["Kharghar Outstation Cab Service", "Kharghar One Way Outstation Cab"],
  ["Kharghar Tourist Cab", "Kharghar Intercity Taxi Service"],
  ["Kharghar Private Taxi Service", "Kharghar to Pune Cab"],
  ["Kharghar to Pune Cab Service", "Kharghar to Pune Taxi"],
  ["Kharghar to Pune Taxi Service", "Kharghar to Pune One Way Cab"],
  ["Kharghar to Pune Outstation Cab", "Kharghar to Goa Cabs"],
  ["Kharghar to Goa Cab Service", "Kharghar to Goa Taxi"],
  ["Kharghar to Goa Taxi Service", "Kharghar to Goa One Way Cab"],
  ["Kharghar to Goa Outstation Cab", "Best Kharghar to Goa Cab"],
  ["Cheap Kharghar to Goa Taxi", "Online Kharghar to Goa Cab Booking"],
  ["Kharghar to Nashik Cab", "Cab Service in Kharghar"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Kharghar Taxi Service",
    WhyChoosedescription: "Om Sai Cab Service provides reliable Kharghar taxi service with professional drivers, comfortable vehicles, and smooth travel for local rides, airport transfers, and outstation journeys."
  },
  {
    WhyChooseheading: "Affordable Kharghar Taxi Fare",
    WhyChoosedescription: "Our Kharghar taxi service offers affordable pricing with transparent fare details and no hidden charges for local and outstation travel bookings."
  },
  {
    WhyChooseheading: "24/7 Kharghar Cab Availability",
    WhyChoosedescription: "Om Sai Cab Service operates 24 hours a day for Kharghar cab bookings including airport pickups, railway station transfers, corporate travel, and emergency transportation."
  },
  {
    WhyChooseheading: "Comfortable & Clean AC Taxis",
    WhyChoosedescription: "All Kharghar taxis are fully air-conditioned, sanitized, spacious, and regularly maintained for smooth and comfortable travel experiences."
  },
  {
    WhyChooseheading: "Local & Outstation Taxi Booking Options",
    WhyChoosedescription: "Customers can book local Kharghar taxi service, one-way cabs, round-trip travel, airport transfers, and customized outstation travel packages."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Choices",
    WhyChoosedescription: "Om Sai Cab Service offers sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers suitable for individuals, families, tourists, and group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Kharghar",
    WhyChoosedescription: "We provide convenient pickup service from Sector 10, Sector 12, Sector 20, Central Park, Utsav Chowk, offices, homes, hotels, and all major Kharghar locations."
  },
  {
    WhyChooseheading: "Experienced Drivers for City & Highway Routes",
    WhyChoosedescription: "Our experienced drivers are familiar with Kharghar city roads, airport routes, highways, and nearby destinations to ensure safe and timely travel."
  }
]
};

const faqData = [
  {
    question: "What is Kharghar taxi service?",
    answer: "Kharghar taxi service provides comfortable taxi transportation for local travel, airport transfers, business rides, and outstation journeys."
  },
  {
    question: "Is Kharghar taxi service available 24 hours?",
    answer: "Yes, Om Sai Cab Service provides 24/7 Kharghar taxi service."
  },
  {
    question: "Which vehicles are available for Kharghar travel?",
    answer: "Customers can choose sedan taxis, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers."
  },
  {
    question: "Can I book one-way and round-trip taxis in Kharghar?",
    answer: "Yes, one-way as well as round-trip Kharghar taxi bookings are available."
  },
  {
    question: "Do you provide airport pickup and drop service from Kharghar?",
    answer: "Yes, Om Sai Cab Service provides airport pickup and drop service for Mumbai Airport and Navi Mumbai Airport routes."
  },
  {
    question: "Are all Kharghar taxis air-conditioned?",
    answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel."
  },
  {
    question: "Can I book Kharghar taxi service online?",
    answer: "Yes, customers can easily book Kharghar taxi service online or through phone booking."
  },
  {
    question: "Do you provide taxis for family and corporate travel?",
    answer: "Yes, comfortable vehicles are available for family travel, business meetings, and corporate transportation."
  },
  {
    question: "Are Kharghar taxi fares transparent?",
    answer: "Yes, Om Sai Cab Service provides affordable and transparent pricing without hidden charges."
  },
  {
    question: "Is advance booking available for Kharghar taxi service?",
    answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel hours."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajiv More",
    feedback: "Used Om Sai Cab Service for local travel in Kharghar and had a very smooth experience. The taxi arrived on time, and the ride was comfortable and well-managed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aarti Shinde",
    feedback: "For our Kharghar taxi needs, Om Sai Cab Service provided quick response and reliable service. The cab was clean, and the driver was polite and professional throughout the trip.",
    rating: 5
  }
];
















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai to Goa Cab", link: "Mumbai-to-Goa-Cab" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Goa Cab Booking", link: "Mumbai-to-Goa-Cab-Booking" },
        { place: "/images/keyword/3.jpg", text: "Navi Mumbai to Goa Cab Service", link: "Navi-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/4.jpg", text: "Mumbai Airport to Goa Cab", link: "Mumbai-Airport-to-Goa-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Goa Cab Service", link: "Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Best Mumbai to Goa Cab Service", link: "Best-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/7.jpg", text: "Thane to Goa Cabs", link: "Thane-to-Goa-Cabs" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Goa Innova Crysta Cab", link: "Mumbai-to-Goa-Innova-Crysta-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Goa One Way Cab", link: "Mumbai-to-Goa-One-Way-Cab" },
        { place: "/images/keyword/10.jpg", text: "Goa Cabs Service", link: "Goa-Cabs-Service" },
        { place: "/images/keyword/11.jpg", text: "Goa to Mumbai Cab", link: "Goa-to-Mumbai-Cab" },
        { place: "/images/keyword/12.jpg", text: "Goa to Navi Mumbai Cab", link: "Goa-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/13.jpg", text: "Goa to Mumbai Airport Cab", link: "Goa-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/14.jpg", text: "Goa to Mumbai One Way Cab", link: "Goa-to-Mumbai-One-Way-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/16.jpg", text: "Lonavala to Mumbai Cab", link: "Lonavala-to-Mumbai-Cab" },
        { place: "/images/keyword/17.jpg", text: "Best Lonavala to Navi Mumbai Cab", link: "Best-Lonavala-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/18.jpg", text: "Navi Mumbai Airport Cab", link: "Navi-Mumbai-Airport-Cab" },
        { place: "/images/keyword/19.jpg", text: "Navi Mumbai Cab Service", link: "Navi-Mumbai-Cab-Service" },
        { place: "/images/keyword/20.jpg", text: "Kharghar Taxi Services", link: "Kharghar-Taxi-Services" },
        { place: "/images/keyword/21.jpg", text: "Mumbai Airport Cabs", link: "Mumbai-Airport-Cabs" },
        { place: "/images/keyword/22.jpg", text: "Mumbai Cab Service", link: "Mumbai-Cab-Service" },
        { place: "/images/keyword/23.jpg", text: "Mumbai Online Cab Service", link: "Mumbai-Online-Cab-Service" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/25.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/26.jpg", text: "Innova Crysta On Rent in Mumbai", link: "Innova-Crysta-On-Rent-in-Mumbai" },
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kharghar Taxi Services",
  "image": "http://www.omsaicabservice.com/assets/images/kharghar-taxi-service.jpg",
  "description": "Book Kharghar taxi service with Om Sai Cab Service for local, airport, and outstation travel. Affordable AC cab, one-way taxi, and intercity travel options available for Kharghar, Navi Mumbai, Pune routes, and tourist trips with 24x7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Om Sai Cab Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "http://www.omsaicabservice.com/kharghar-taxi-services"
  }
};



    return (
        <div>

<Helmet>
  <title>
    Kharghar Taxi Services | Local, Airport & Outstation Cab | +91 9594849797
  </title>

  <meta
    name="description"
    content="Book Kharghar taxi services for local rides, airport transfers, and outstation trips. Affordable AC cabs, one-way taxis, and tourist cab services available for Kharghar to Pune and other routes with 24x7 support."
  />

  <meta
    name="keywords"
    content="cab service in kharghar, Kharghar Taxi Services, Kharghar Cab Service, Kharghar Taxi Booking, Kharghar Outstation Taxi, Kharghar AC Cab Service, Kharghar Airport Taxi, Kharghar Tourist Taxi Service, Kharghar One Way Cab, Kharghar Outstation Cab, Kharghar Outstation Cab Service, Kharghar One Way Outstation Cab, Kharghar Tourist Cab, Kharghar Intercity Taxi Service, Kharghar Private Taxi Service, Kharghar to Pune Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<Helmet>
  <title>
    Kharghar Taxi Services | Local, Airport & Outstation Cab | +91 9594849797
  </title>

  <meta
    name="description"
    content="Book Kharghar taxi services for local rides, airport transfers, and outstation trips. Affordable AC cabs, one-way taxis, and tourist cab services available for Kharghar to Pune and other routes with 24x7 support."
  />

  <meta
    name="keywords"
    content="cab service in kharghar, Kharghar Taxi Services, Kharghar Cab Service, Kharghar Taxi Booking, Kharghar Outstation Taxi, Kharghar AC Cab Service, Kharghar Airport Taxi, Kharghar Tourist Taxi Service, Kharghar One Way Cab, Kharghar Outstation Cab, Kharghar Outstation Cab Service, Kharghar One Way Outstation Cab, Kharghar Tourist Cab, Kharghar Intercity Taxi Service, Kharghar Private Taxi Service, Kharghar to Pune Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row align-items-center text-center">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/20.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FFCC00', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Om Sai Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Om Sai Cab</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Om Sai Cab </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                             <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919594849797" className="pc-call">+91 9594849797</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919594849797"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919594849797" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@omsaicabservice.com" className="pc-email">
                                            booking@omsaicabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Om Sai Cab Service</strong><br />
                                            Shree Vishal CHS Ltd., Plot No.17,
                                            Sector 18, Kopar Khairane, Navi Mumbai,
                                            Maharashtra- India - 400709
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Kharghartaxiservice;